import { Col, Row } from 'react-bootstrap';
import ClientProfileCard from '../components/admin/clients/clientDetail/ClientProfileCard';
import AdminLayout from './layout/AdminLayout';

const ClientDetail = () => {

    return (
        <AdminLayout>
            <Row>
                <Col className='container'>
                    <ClientProfileCard />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default ClientDetail;